// extracted by mini-css-extract-plugin
module.exports = {"comp":"ActivityA3_comp__Ouw3c"};